import { useQuery } from "@tanstack/react-query"
import { Outlet, useLocation, useNavigate } from "react-router-dom"


import { useEffect } from "react";
import { AxiosError } from "axios";
import { useAuthStore } from "@/store";
import api from "@/http/api";
import Loader from "@/components/Loader";

const getSelf = async () => {
    const { data } = await api.get(`/admin/self`);
    return data
}

const Root = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const { setUser, setNotificationCount } = useAuthStore()
    const { data, isPending, isError } = useQuery({
        queryKey: ['self'],
        queryFn: getSelf,
        retry: (failureCount, error) => {
            if (error instanceof AxiosError && error?.response?.status === 401) {
                return false
            }
            return failureCount < 1
        },

    })

    // Set user and notification count only when data actually changes (initial fetch / refetch)
    useEffect(() => {
        if (!isPending && data?.user) {
            setUser(data.user);
            setNotificationCount(data.unseenNotifications)
        }
    }, [data, isPending])

    // Handle auth redirects separately so route changes don't re-trigger the data effect
    useEffect(() => {
        if (!isPending) {
            if (data?.user) {
                if (location.pathname === '/') {
                    navigate('/')
                }
            } else {
                navigate("/login");
            }
        }
    }, [data, isPending, isError, navigate, location.pathname])

    if (isPending) {
        return <Loader />
    }

    return <Outlet />
}

export default Root